import { render, staticRenderFns } from "./DictionaryValueTable.vue?vue&type=template&id=53b56800&scoped=true"
import script from "./DictionaryValueTable.vue?vue&type=script&lang=js"
export * from "./DictionaryValueTable.vue?vue&type=script&lang=js"
import style0 from "./DictionaryValueTable.vue?vue&type=style&index=0&id=53b56800&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b56800",
  null
  
)

export default component.exports